import React, { useState } from "react";
// import emailjs from "emailjs-com";
import { TextField, Button, Dialog } from "@mui/material";

import thumb from "../../images/contacto.png";
import "./Contacto.css";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/high-res.css";
import es from "react-phone-input-2/lang/es.json";

export const Contacto = () => {
  const secret_key = process.env.GOOGLE_RECAPTCHA_SECRET_KEY
    ? process.env.GOOGLE_RECAPTCHA_SECRET_KEY
    : `6LeIcfMpAAAAAIwzPzhCyaB8v8qvLAcp_9livuyR`;
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    country: "",
    message: "",
    phone: {
      country_code: "",
      number: "",
    },
    company: "Ellie Care",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [invalidRecaptcha, setInvalidRecaptcha] = useState(true);

  function onChange(token: string | null) {
    if (token) {
      setInvalidRecaptcha(false);
    } else {
      setInvalidRecaptcha(true);
    }
  }

  const [formStatus, setFormStatus] = useState<string[]>([]);

  const extractTextFromHtml = (htmlString: string): string[] => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const spans = doc.querySelectorAll('span');
    const texts = Array.from(spans).map(span => span.textContent || '');
    return texts;
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // portalId: "46059548",
    // formId: "becf018d-9a4c-4756-b3d6-43e0f8573487"

    const url = `https://api.hsforms.com/submissions/v3/integration/submit/46059548/becf018d-9a4c-4756-b3d6-43e0f8573487`;

    const data = {
      fields: [
        { name: "firstname", value: formData.firstname },
        { name: "lastname", value: formData.lastname },
        { name: "email", value: formData.email },
        { name: "country", value: formData.country },
        { name: "message", value: formData.message },
        {
          name: "phone",
          value: `+${formData.phone.country_code} ${formData.phone.number}`,
        },
        { name: "company", value: "Ellie Care"}
      ],
      context: {
        pageUri: window.location.href,
        pageName: document.title,
      },
      legalConsentOptions: {
        consent: {
          consentToProcess: true,
          text: "Acepto permitir el procesamiento de mis datos.",
          communications: [
            {
              value: true,
              subscriptionTypeId: 999,
              text: "Acepto recibir comunicaciones.",
            },
          ],
        },
      },
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      setFormStatus(["Enviando mensaje..."])
      setModalIsOpen(true);

      if (response.ok) {
        const responseData = await response.json();
        const extractedTexts = extractTextFromHtml(responseData.inlineMessage || 'Formulario enviado con éxito.');
        setFormStatus(
          extractedTexts
          // responseData.inlineMessage || "Formulario enviado con éxito."
        );
        setModalIsOpen(true);
        
        setFormData({
          ...formData,
          phone: {
            country_code: "",
            number: "",
          },
          firstname: "",
          lastname: "",
          email: "",
          message: "",
        });

        // alert(responseData.inlineMessage || 'Formulario enviado con éxito.'
        //  "¡Muchas gracias por contactarnos y por tu interés en Ellie Care!\n\nEstamos aquí para ayudarte y asegurar el bienestar de tus seres queridos. Con nuestro innovador Ellie Watch, monitoreamos en tiempo real la ubicación, frecuencia cardíaca y estado de salud de tus adultos mayores.\n\nEn caso de una caída o situación de emergencia, nuestro centro de atención llamará al adulto y contactará a sus familiares y a sus servicios de salud para una rápida asistencia.\n\nUno de nuestros asesores se pondrá en contacto contigo pronto para brindarte más información sobre el servicio y los planes disponibles.\n\nSaludos,\n\nEllie Care"
        //);
      } else {
        const responseData = await response.json();
        // setFormStatus(responseData.message || "Error al enviar el formulario.");
        const extractedTexts = extractTextFromHtml(responseData.message || 'Error al enviar el formulario.');
        setFormStatus(extractedTexts);
        //setModalIsOpen(true);

        alert("Error al enviar el formulario");
      }
    } catch (error) {
      console.error("Error:", error);
      // setFormStatus("Error al enviar el formulario.");
      const extractedTexts = extractTextFromHtml('Error al enviar el formulario.');
      setFormStatus(extractedTexts);
      //setModalIsOpen(true);

      alert("Error al enviar el formulario");
    }
  };

  return (
    <div id="contacto">
      <div className="contacto-form-image">
        <div className="contacto-container-title-image">
          <div className="contacto-box" style={{ marginTop: "16px" }}>
            <strong>¿Te interesan nuestros productos y servicios?</strong>
          </div>
          <div className="contacto-box">
            <h1 style={{ color: "#0066FF" }}>¡Contactanos!</h1>
          </div>
          <img src={thumb} alt="Contactanos!" />
        </div>

        <form className="contacto-container" onSubmit={handleSubmit}>
          <div className="contacto-box">
            <TextField
              className="contacto-textfield"
              label="Nombre"
              name="firstname"
              value={formData.firstname}
              onChange={handleChange}
              required
              margin="normal"
              InputProps={{
                style: { fontFamily: "Quicksand", fontSize: "16px" },
              }}
              InputLabelProps={{
                style: { fontFamily: "Quicksand", fontSize: "16px" },
              }}
              FormHelperTextProps={{
                style: {
                  fontFamily: "Quicksand",
                  fontSize: "14px",
                  color: "red",
                },
              }}
              style={{ backgroundColor: "#FFFFFF", borderRadius: "5px" }}
            />
            <TextField
              className="contacto-textfield"
              label="Apellidos"
              name="lastname"
              value={formData.lastname}
              onChange={handleChange}
              required
              margin="normal"
              InputProps={{
                style: { fontFamily: "Quicksand", fontSize: "16px" },
              }}
              InputLabelProps={{
                style: { fontFamily: "Quicksand", fontSize: "16px" },
              }}
              style={{ backgroundColor: "#FFFFFF", borderRadius: "5px" }}
            />
          </div>
          <div className="contacto-box">
            <TextField
              className="contacto-textfield"
              label="Correo"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
              margin="normal"
              InputProps={{
                style: { fontFamily: "Quicksand", fontSize: "16px" },
              }}
              InputLabelProps={{
                style: { fontFamily: "Quicksand", fontSize: "16px" },
              }}
              style={{ backgroundColor: "#FFFFFF", borderRadius: "5px" }}
            />
            <div className="phone-input">
              <PhoneInput
                autocompleteSearch={true}
                // country={"ar"}
                // onlyCountries={["ar", "uy", "mx", "co", "cl", "pe"]}
                preferredCountries={["ar", "uy", "mx", "co", "cl", "pe"]}
                placeholder="País * y N° de teléfono"
                inputStyle={{
                  height: "56px",
                  width: "100%",
                  fontSize: "1rem",
                  paddingLeft: "70px",
                  backgroundColor: "#ffffff",
                  fontFamily: "Quicksand",
                  border: "1px solid #c4c4c4",
                }}
                buttonStyle={{
                  width: "56px",
                  height: "56px",
                  paddingLeft: "4px",
                  backgroundColor: "#ffffff",
                  fontFamily: "Quicksand",
                }}
                localization={es}
                // value={formData.shipping_phone_number}
                onChange={(value, country, e, formattedValue) => {
                  // console.log("Value:" + value);
                  // console.log(country);
                  if (country && "dialCode" in country) {
                    setFormData({
                      ...formData,
                      phone: {
                        country_code: country.dialCode,
                        number: value.substring(country.dialCode.length),
                      },
                      country: country.name,
                    });
                    // console.log(
                    //   "dialCode:" + formData.billing_phone_number.country_code
                    // );
                    // console.log(
                    //   "number:" + formData.billing_phone_number.number
                    // );
                    // console.log("---------------------------------:");
                  }
                }}
                inputProps={{
                  required: true,
                }}
              />
            </div>
          </div>
          <div className="contacto-box">
            <TextField
              label="Mensaje"
              name="message"
              value={formData.message}
              onChange={handleChange}
              fullWidth
              required
              multiline
              rows={3}
              margin="normal"
              InputProps={{
                style: {
                  fontFamily: "Quicksand",
                  fontSize: "16px",
                  color: "#000000",
                },
              }}
              InputLabelProps={{
                style: { fontFamily: "Quicksand", fontSize: "16px" },
              }}
              style={{ backgroundColor: "#FFFFFF", borderRadius: "5px" }}
            />
          </div>

          <div className="contacto-box" style={{ marginTop: "15px" }}>
            <ReCAPTCHA sitekey={secret_key} onChange={onChange} size="normal" />
            <Button
              className="contacto-button"
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={invalidRecaptcha}
            >
              Enviar
            </Button>
          </div>
        </form>
      </div>
      <Dialog open={modalIsOpen} onClose={() => setModalIsOpen(false)} >
        <div style={{ margin: "30px" }}>
          {/* <div dangerouslySetInnerHTML={{ __html: formStatus }} > */}
          {formStatus.map((text, index) => (
            <p key={index} style={{ fontFamily: 'Quicksand, sans-serif', fontSize: '16px', textAlign: 'center' }}>
              {text}
            </p>
          ))}
          <Button
            variant="contained"
            color="success"
            fullWidth
            onClick={() => setModalIsOpen(false)}
          >
            Cerrar
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

export default Contacto;
